














import Vue from 'vue';
import Component from 'vue-class-component';
import { Emit, Prop } from 'vue-property-decorator';

@Component({})
export default class PaginationComponent extends Vue {
    @Prop() public loading: boolean;

    @Prop() public total: number;

    @Prop() public page: number;

    @Prop() public pageSize: number;

    public mounted() {
        window.onkeyup = (event: KeyboardEvent) => {
            this.keyboardPaging(event);
        };
    }

    public destroyed() {
        window.onkeyup = null;
    }

    get pagesTotal(): number {
        return Math.ceil(this.total / this.pageSize);
    }

    public prev() {
        if (this.page > 1) {
            this.change(this.page - 1);
        }
    }

    public next() {
        if (this.page < this.pagesTotal) {
            this.change(this.page + 1);
        }
    }

    public keyboardPaging(event: KeyboardEvent) {
        if (event.ctrlKey) {
            if (event.key === 'ArrowLeft') {
                this.prev();
            }
            if (event.key === 'ArrowRight') {
                this.next();
            }
        }
    }

    @Emit()
    public change(page: number) {
        // empty
    }
}
